import axiosService from "lib/axios";
import { useQuery } from "@tanstack/react-query";

const route = "/jobs";
export async function getJobs(page:number, limit:number, search?:string,field?:string):Promise<{
    jobs:Job[];
    page:number;
    limit:number;
    totalCount:string;
}> {
    const { data } = await axiosService.get(route, {
        params: { page, limit, search, field },
    });
    if (data.count) {
        window.localStorage.setItem("totalCountJobs", data.count);
    }
    return {
        jobs: data.jobs,
        page: data.page,
        limit: data.limit,
        totalCount: data.count || window.localStorage.getItem("totalCountJobs"),
    };
}

async function getJob (id:string):Promise<{
    job:Job;
    jobDetailsCount:string
}> {
    const { data } = await axiosService.get(`${route}/${id}`);
    return data;
}

export function useGetJob(id:string){
    return useQuery(["job", id], ()=>getJob(id));
}

export function deleteJobs (ids: number[] | string[], secretKey: string){
    return axiosService.delete(route, {data: {ids, secretKey}});
} 

export function deleteSingleJob (id: number | string, secretKey: string){
    return axiosService.delete(`${route}/${id}?secretKey=${secretKey}`);
}

export function resetJob (id: number | string, secretKey: string){
    return axiosService.put(`${route}/reset/${id}?secretKey=${secretKey}`);
}

type ISPDetails = {
    [key: string]: {
      value: number;
    };
  };

export interface Job{
    id:number;
    name:string;
    monday:boolean;
    tuesday:boolean;
    wednesday:boolean;
    thursday:boolean;
    friday:boolean;
    saturday:boolean;
    sunday:boolean;
    day_last_mailed:string;
    include_ISP:string;
    exclude_ISP:string;
    mailwizz_campaign:string;
    mailSystemList:string;
    selected_list?: string | null;
    mailwizz_list?: string | null;
    launchDate: string;
    includeISP: string[];
    recurring:boolean;
    ispDetails: ISPDetails;
    status:string;
    list_ids:number[];
    launch_date: string;
    notes:string;
    scrubbedProfileForEmail:number;
    submit?: string;
}
export async function createJob(job:Partial<Job>){
    const { data } = await axiosService.post(route, job);
    return data;
}

export async function editJob(job:Partial<Job>){
    const { data } = await axiosService.put(`${route}/${job.id}`, job);
    return data;
}